import VendorPricingForm from "./VendorPricingForm";
import {useState} from "react";

const CreateVendorPricing = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Vendor Pricing", url: "/accounting/vendor-pricing"},
        {content: "Add Vendor Pricing", url: "/accounting/vendor-pricing/create"},
    ]);

    return (
        <>
            <VendorPricingForm crumbs={crumbs}
                               title={"Add Vendor Pricing"}
                               btnText={"Add"}></VendorPricingForm>
        </>
    )
}
export default CreateVendorPricing;